import { render, staticRenderFns } from "./SignUpList.vue?vue&type=template&id=28bffce4&"
import script from "./SignUpList.vue?vue&type=script&lang=js&"
export * from "./SignUpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports